import "./adminpanel.css";
import { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Slidebar from "../SlideBar/SlideBar";
import Taskbar from "../taskBar/Taskbar";
import { useGlobalContext } from "../../../Context/Context";
import picture0 from "../../picture/0.png";
import picture8 from "../../picture/8.png";
import axios from "axios";
import { resize } from "./resize.js";

function Adminpanel({ timeUnlockCurrent, account, setSelectAccount }) {
  const searchParams = new URLSearchParams(window.location.search);
  const isOpening = searchParams.get("opening") === "true";
  const openingType = parseInt(searchParams.get("type"), 10); // NaN ako nema type

  console.log("isOpening:", isOpening);
  console.log("openingType:", openingType);

  const [isCardActive, setIsCardActive] = useState(false);
  const [currentTab, setCurrentTab] = useState(null);
  const [speakerButton, setSpeakerButton] = useState([
    { name: "PROMO", active: 0, picture: picture0 },
    { name: "COOPERATION", active: 0, picture: picture0 },
    { name: "HR", active: 0, picture: picture0 },
  ]);
  const [languageButton, setLanguageButton] = useState([
    { name: "LOCATION LANGUAGE", active: 0, picture: picture8 },
    { name: "TRANSLATE", active: 0, picture: picture8 },
  ]);
  const [selectedItem, setSelectedItem] = useState({
    locations: false,
    users: false,
  });
  const [companies, setCompanies] = useState([]);
  const [windowResized, setWindowResized] = useState(false);
  const [showList, setShowList] = useState([]);

  const {
    setCancelIndex,
    setActiveStates,
    setActiveIconsMiddleAdmin,
    selectedCompany,
    selectedAccount,
    selectedMainEntity,
  } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();
  const { activeIcons, setActiveIcons } = useGlobalContext();
  const { baseUrl, slideButton, setSlideButton } = useGlobalContext();

  const checkIfNoOneActive = () => {
    if (slideButton.find((item) => item.active > 0) !== undefined) return true;
    else return false;
  };

  window.addEventListener("resize", () =>
    resize(window.innerWidth, window.innerHeight, setWindowResized),
  );

  //   useEffect(() => {

  //       window.location.reload();
  // }, []);

  useEffect(() => {
    console.log("loggedUser:", loggedUser);
    console.log("apiKey:", apiKey);
    if (loggedUser?.id && apiKey) {
      // <-- proveri i apiKey
      const fetchData = async () => {
        try {
          const { data } = await axios.post(
            `${baseUrl}/admin_panel/companies/readParentCompanies.php`,
            { user_id: loggedUser.id, api_key: apiKey },
          );
          if (data.status === 200) {
            setCompanies(data.data);
            setShowList(data.data);
          }
        } catch (e) {
          console.log(e);
          if (e.status === 404) {
            setCompanies([]);
            setShowList([]);
          }
        }
      };
      fetchData();
      resize(window.innerWidth, window.innerHeight, setWindowResized);
    }
  }, [loggedUser?.id, apiKey]); // <-- dodaj apiKey ovde

  useEffect(() => {
    if (currentTab === null || activeIcons.length !== 0) setCancelIndex(null);
  }, [currentTab]);

  useEffect(() => {
    setActiveStates([]);
    setActiveIconsMiddleAdmin([]);
    if (selectedCompany !== null && selectedCompany.accounts.length !== 0) {
      const { accounts, ...rest } = selectedCompany;
      const selectedAccounts = [rest, ...selectedCompany.accounts];
      setShowList(selectedAccounts);
    }
    if (selectedCompany === null) {
      let buttons = [];
      buttons = slideButton.map((btn) => ({ ...btn, active: 0 }));
      setSlideButton(buttons);
      buttons = speakerButton.map((btn) => ({ ...btn, active: 0 }));
      setSpeakerButton(buttons);
      buttons = languageButton.map((btn) => ({ ...btn, active: 0 }));
      setLanguageButton(buttons);
    }
  }, [selectedCompany]);

  useEffect(() => {
    setActiveStates([]);
    setActiveIconsMiddleAdmin([]);
  }, [selectedAccount]);

  return (
    <>
      <div
        className={`${
          timeUnlockCurrent ? "admin-panel" : "admin-panel not-clickable"
        }`}
      >
        {companies.length !== 0 && (
          <Navbar
            isCardActive={isCardActive}
            setIsCardActive={setIsCardActive}
            showList={showList}
            setShowList={setShowList}
            companies={companies}
            checkIfNoOneActive={checkIfNoOneActive}
            setCurrentTab={setCurrentTab}
            currentTab={currentTab}
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
            timeUnlockCurrent={timeUnlockCurrent}
            setSelectAccount={setSelectAccount}
            isOpening={isOpening}
            openingType={openingType}
          />
        )}
        <Taskbar
          languageButton={languageButton}
          speakerButton={speakerButton}
          slideButton={slideButton}
          setSlideButton={setSlideButton}
          setSpeakerButton={setSpeakerButton}
          setLanguageButton={setLanguageButton}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          activeIcons={activeIcons}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          setCompanies={setCompanies}
          setSelectAccount={setSelectAccount}
          account={account}
        />
        <Slidebar
          isCardActive={isCardActive}
          slideButton={slideButton}
          speakerButton={speakerButton}
          languageButton={languageButton}
          setSlideButton={setSlideButton}
          setSpeakerButton={setSpeakerButton}
          setLanguageButton={setLanguageButton}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          setActiveIcons={setActiveIcons}
          activeIcons={activeIcons}
          checkIfNoOneActive={checkIfNoOneActive}
          selectedCompany={selectedMainEntity}
        />
      </div>
    </>
  );
}

export default Adminpanel;
